<template>
    <div class="form_group with_edit_btn">
        <label class="form_text_label">
            <span class="editable_text">{{localData.label}}</span>
            <span class="star">*</span>
        </label>
        <div class="full_width_select def_select">
            <Select2
                class="select-editor"
                :settings="select2Settings"
                :options="localData.options"
                v-model="localData.value"
                :placeholder="localData.placeholder"
            />
        </div>
    </div>
</template>

<script>
export default {
    name: 'FormSelect',
    props: ["index", "formElementData", "step"],
    data: function(){
        return {
            select2Settings: { dropdownAutoWidth: false, width: '100%' },
            localSelected: '',
            localData: {
                label: '',
                value: ''
            },
        }
    },
    methods: {
    },
    created() {
        this.localData = JSON.parse(JSON.stringify(this.formElementData));
    }
}
</script>